export enum OperationCommunicationStatusEnum {
    OPERATION_COMMUNICATION_UNKNOWN = 'OPERATION_COMMUNICATION_UNKNOWN',
    OPERATION_COMMUNICATION_SUGGESTED = 'OPERATION_COMMUNICATION_SUGGESTED',
    OPERATION_COMMUNICATION_NOT_SUGGESTED = 'OPERATION_COMMUNICATION_NOT_SUGGESTED',
    OPERATION_COMMUNICATION_TO_COMMUNICATE = 'OPERATION_COMMUNICATION_TO_COMMUNICATE',
    OPERATION_COMMUNICATION_COMMUNICATED = 'OPERATION_COMMUNICATION_COMMUNICATED',
    OPERATION_COMMUNICATION_NOT_COMMUNICATED = 'OPERATION_COMMUNICATION_NOT_COMMUNICATED'
}